import { PayloadAction } from "@reduxjs/toolkit";

export function addBusyHistoryItemReducer(state, action: PayloadAction<string>) {
  state.busy.push(action.payload);
}
export function removeBusyHistoryItemReducer(state, action: PayloadAction<string>) {
  state.busy = state.busy.filter((i) => i !== action.payload);
}
